/**
 *
 * @description HDD领取新用户礼包弹窗页
 */

import {
    getProductCouponGift,
    postProductCouponFree,
} from '@/api/hdd/leftPanel.js';
import closeIcon from '@/assets/img/hdd/renderingCoupons/closeIcon.png';
import headerLogo from '@/assets/img/hdd/renderingCoupons/headerLogo.png';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import './index.exclude.scss';

function GiveRenderingCoupons() {
    const [couponsList, setCouponsListList] = useState([]);

    usePreventDefault();

    const queryList = async () => {
        try {
            const res = await getProductCouponGift();
            const list = res.data.map(item => {
                return {
                    num: item.num,
                    name: item.couponName,
                    tip: item.remark,
                    type: item.couponName.indexOf('全景') !== -1 ? 2 : 1,
                    date: item.effective_days,
                };
            });
            setCouponsListList(list);
        } catch (e) {}
    };

    useEffect(queryList, []);

    const inprogress = useRef(false);
    const getCoupon = () => {
        if (inprogress.current) return;
        inprogress.current = true;
        postProductCouponFree().finally(() => {
            try {
                inprogress.current = false;
                window.external.DispatchFun(
                    'StartPage',
                    'CloseRender',
                    '/hdd/giveRenderingCoupons'
                );
            } catch {}
        });
    };

    return (
        <div className="give_rendering_coupons">
            <div className="modal-header">
                <h2>新人福利大礼包</h2>
                <img className="logo-img" src={headerLogo} alt="" />
                <img
                    className="close-btn"
                    onClick={getCoupon}
                    src={closeIcon}
                    alt=""
                />
            </div>
            <div className="modal-content">
                <ul className="list-box">
                    {couponsList.map((item, index) => {
                        return (
                            <li
                                className={`item-box ${
                                    item.type === 2 ? 'all-coupons' : ''
                                }`}
                                key={index}>
                                <div className="item-left">
                                    <p>{item.num}</p>
                                    <span>张</span>
                                </div>
                                <div className="item-right">
                                    <h4>{item.name}</h4>
                                    <p>{item.tip}</p>
                                </div>
                                <span className="white-block top" />
                                <span className="white-block bottom" />
                            </li>
                        );
                    })}
                </ul>
                <span className="receive-btn" onClick={getCoupon}>
                    立即领取
                </span>
                <p className="receive-tip">
                    有效期{couponsList?.[0]?.data || 7}天，请尽快使用哦！
                </p>
            </div>
        </div>
    );
}

export default GiveRenderingCoupons;
